import script from "./PwaEmployees.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaEmployees.vue?vue&type=script&setup=true&lang=ts"

import "./PwaEmployees.vue?vue&type=style&index=0&id=84d5593c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84d5593c"]])

export default __exports__